<template>
	<div class="log-container">
		<!-- 查询区域 -->
		<el-card shadow="never" class="search-card">
			<el-form :model="searchForm" inline label-width="90px" ref="searchForm">
				<el-form-item label="日志类型">
					<el-select v-model="searchForm.logType" placeholder="请选择日志类型" clearable>
						<el-option label="正常日志" value="normal" />
						<el-option label="异常日志" value="error" />
					</el-select>
				</el-form-item>
				<el-form-item label="查询日期">
					<el-date-picker v-model="searchForm.day" type="date" format="yyyy-MM-dd" value-format="yyyyMMdd"
						placeholder="选择日期"></el-date-picker>
				</el-form-item>
				<el-form-item label="TraceId">
					<el-input v-model="searchForm.traceId" placeholder="精准追踪ID"></el-input>
				</el-form-item>
				<el-form-item label="接口名称">
					<el-input v-model="searchForm.apiName" placeholder="模糊搜索接口"></el-input>
				</el-form-item>
				<el-form-item label="请求方式">
					<el-select v-model="searchForm.requestMethod" placeholder="全部" clearable>
						<el-option label="GET" value="GET" />
						<el-option label="POST" value="POST" />
						<el-option label="PUT" value="PUT" />
						<el-option label="DELETE" value="DELETE" />
					</el-select>
				</el-form-item>
				<el-form-item label="响应状态">
					<el-select v-model="searchForm.responseStatus" placeholder="全部" clearable>
						<el-option label="200成功" value="200" />
						<el-option label="401token异常" value="401" />
						<el-option label="500异常" value="500" />
					</el-select>
				</el-form-item>
				<el-form-item label="操作人名称">
					<el-input v-model="searchForm.userName" placeholder="模糊搜索用户名称"></el-input>
				</el-form-item>
				<el-form-item label="操作平台">
					<el-select v-model="searchForm.platform" placeholder="全部平台" clearable>
						<el-option label="1-中台" value="1" />
						<el-option label="2-学校用户" value="2" />
						<el-option label="3-学生" value="3" />
						<el-option label="4-家长" value="4" />
						<el-option label="5-教育局用户" value="5" />
					</el-select>
				</el-form-item>
				<el-form-item label="耗时区间">
					<el-input v-model="searchForm.costMin" style="width: 80px" placeholder="最小ms"></el-input>
					<span style="margin:0 8px">-</span>
					<el-input v-model="searchForm.costMax" style="width: 80px" placeholder="最大ms"></el-input>
				</el-form-item>

				<el-form-item label="异常信息" v-if="searchForm.logType === 'error'">
					<el-input v-model="searchForm.errorMsg" placeholder="模糊搜索报错信息"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="loadData">查询</el-button>
					<el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top:10px">
			<el-table :data="tableData" border stripe v-loading="loading" max-height="calc(100vh - 320px)">
				<el-table-column label="序号" width="60" align="center">
					<template slot-scope="scope">
						{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}
					</template>
				</el-table-column>
				<el-table-column label="TraceId" prop="traceId" min-width="220" />
				<el-table-column label="接口名称" prop="apiName" min-width="160" />
				<el-table-column label="操作人" prop="userName" width="120" />
				<el-table-column label="请求地址" prop="requestUrl" min-width="240" />
				<el-table-column label="方式" prop="requestMethod" width="80" align="center" />
				<el-table-column label="客户端IP" prop="ip" width="140" />
				<el-table-column label="状态码" prop="responseStatus" width="90" align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.responseStatus === 200 ? 'success' : 'danger'">
							{{ scope.row.responseStatus }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作平台" prop="platform" width="120" align="center">
					<template slot-scope="scope">
						<span>{{ getPlatformText(scope.row.platform) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="耗时(ms)" prop="costTime" width="90" align="center" />
				<el-table-column label="记录时间" prop="createTime" width="170">
					<template slot-scope="scope">
						{{forDataTime(scope.row.createTime)}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100" align="center">
					<template slot-scope="scope">
						<el-button type="text" @click="openDetail(scope.row)" icon="el-icon-view">详情</el-button>
						<el-button type="text" @click="copyCurl(scope.row)"
							icon="el-icon-copy-document">复制Curl</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<el-pagination @current-change="handleCurrentChange" :current-page="searchForm.pageNum"
				layout="total, prev, pager, next, jumper" :total="total" style="text-align:right" />
		</el-card>

		<!-- 日志详情弹窗 -->
		<el-dialog title="日志详情" :visible.sync="dialogVisible" width="85%" top="5vh">
			<template v-if="detail">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-descriptions title="基础信息" :column="1" border>
							<el-descriptions-item label="TraceId">{{ detail.traceId }}</el-descriptions-item>
							<el-descriptions-item label="接口名称">{{ detail.apiName }}</el-descriptions-item>
							<el-descriptions-item label="操作人">{{ detail.userName || '-' }}</el-descriptions-item>
							<el-descriptions-item label="请求地址">{{ detail.requestUrl }}</el-descriptions-item>
							<el-descriptions-item label="请求方式">{{ detail.requestMethod }}</el-descriptions-item>
							<el-descriptions-item label="客户端IP">{{ detail.ip }}</el-descriptions-item>
							<el-descriptions-item label="响应状态">{{ detail.responseStatus }}</el-descriptions-item>
							<el-descriptions-item label="耗时(ms)">{{ detail.costTime }}</el-descriptions-item>
							<el-descriptions-item label="记录时间">{{ detail.createTime }}</el-descriptions-item>
						</el-descriptions>
					</el-col>
					<el-col :span="12">
						<el-descriptions title="请求信息" :column="1" border>
							<el-descriptions-item label="URL参数">
								<el-input v-model="detail.requestParams" type="textarea" rows="2" readonly></el-input>
							</el-descriptions-item>
							<el-descriptions-item label="请求体">
								<el-input v-model="detail.requestBody" type="textarea" rows="3" readonly></el-input>
							</el-descriptions-item>
							<el-descriptions-item label="请求头">
								<el-input v-model="detail.requestHeaders" type="textarea" rows="3" readonly></el-input>
							</el-descriptions-item>
						</el-descriptions>
					</el-col>
				</el-row>

				<el-divider></el-divider>

				<!-- 正常日志展示响应体 -->
				<div v-if="searchForm.logType === 'normal'">
					<el-descriptions title="响应返回数据" :column="1" border>
						<el-descriptions-item label="ResponseBody">
							<el-input v-model="detail.responseBody" type="textarea" rows="8" readonly></el-input>
						</el-descriptions-item>
					</el-descriptions>
				</div>

				<!-- 异常日志展示报错信息 -->
				<div v-if="searchForm.logType === 'error'">
					<el-descriptions title="异常信息" :column="1" border>
						<el-descriptions-item label="错误信息">
							<el-input v-model="detail.errorMsg" type="textarea" rows="2" readonly></el-input>
						</el-descriptions-item>
						<el-descriptions-item label="堆栈日志">
							<el-input v-model="detail.stackTrace" type="textarea" rows="12" readonly></el-input>
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</template>
			<div slot="footer">
				<el-button @click="dialogVisible = false">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// import { getLogPage, getLogDetail } from '@/api/logApi'
	export default {
		name: 'LogApi',
		data() {
			return {
				loading: false,
				total: 0,
				tableData: [],
				dialogVisible: false,
				detail: null,
				searchForm: {
					logType: '',
					day: '',
					operator: '',
					traceId: '',
					apiName: '',
					requestUrl: '',
					requestMethod: '',
					responseStatus: null,
					ip: '',
					costMin: '',
					costMax: '',
					errorMsg: '',
					pageNum: 1,
					pageSize: 10,
					userName: '',
					platform: '',
				}
			}
		},
		mounted() {

			// 默认加载当天日期
			const now = new Date()
			const year = now.getFullYear()
			let month = now.getMonth() + 1
			let day = now.getDate()
			month = month < 10 ? '0' + month : month
			day = day < 10 ? '0' + day : day
			this.searchForm.day = `${year}${month}${day}`
		},
		created() {

		},
		methods: {
			getPlatformText(code) {
				const map = {
					'1': '中台',
					'2': '学校用户',
					'3': '学生',
					'4': '家长',
					'5': '教育局用户'
				}
				return map[code] || '-'
			},
			//mg的东八区日志
			forDataTime(val) {
				var str = ''
				if (val) {
					const date = new Date(val);
					// 转为北京时间格式化
					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const day = String(date.getDate()).padStart(2, '0');
					const h = String(date.getHours()).padStart(2, '0');
					const m = String(date.getMinutes()).padStart(2, '0');
					const s = String(date.getSeconds()).padStart(2, '0');
					str = `${year}-${month}-${day} ${h}:${m}:${s}`;
				}
				return str
			},
			async copyCurl(row) {
				try {
					// 1. 解析请求头JSON字符串转对象
					let headersObj = {}
					try {
						headersObj = JSON.parse(row.requestHeaders)
					} catch (e) {
						headersObj = {}
					}

					// 2. 组装基础curl字符串
					let curlLines = []
					// 第一行 curl 'url'
					curlLines.push(`curl '${row.requestUrl}'`)
					// 请求方式（GET不需要-X，POST/PUT/DELETE加-X）
					const method = row.requestMethod.toUpperCase()
					if (method !== 'GET') {
						curlLines.push(`  -X ${method}`)
					}
					// 循环拼接所有请求头
					Object.keys(headersObj).forEach(key => {
						const val = headersObj[key].replace(/'/g, "\\'")
						curlLines.push(`  -H '${key}: ${val}'`)
					})
					// 如果有请求体，拼接 -d json参数
					if (row.requestBody && row.requestBody.trim()) {
						const bodyStr = row.requestBody.replace(/'/g, "\\'")
						curlLines.push(`  -d '${bodyStr}'`)
					}
					// 拼接换行符 \
					const curlText = curlLines.join(" \\\n")

					// 3. 复制到剪贴板（兼容http非安全域名）
					await this.copyToClipboard(curlText)
					this.$message.success("已复制Curl，可直接粘贴到Postman导入！")
				} catch (err) {
					console.error("复制curl失败", err)
					this.$message.error("复制失败")
				}
			},

			// 兼容所有浏览器的复制工具方法（http/https通用）
			copyToClipboard(text) {
				return new Promise((resolve, reject) => {
					// 现代浏览器优先Clipboard API
					if (navigator.clipboard && window.isSecureContext) {
						navigator.clipboard.writeText(text).then(resolve).catch(reject)
					} else {
						// 降级：创建临时textarea兼容http环境
						const textarea = document.createElement("textarea")
						textarea.value = text
						textarea.style.position = "fixed"
						textarea.style.opacity = "0"
						document.body.appendChild(textarea)
						textarea.select()
						document.execCommand("copy")
						document.body.removeChild(textarea)
						resolve()
					}
				})
			},
			// 加载表格数据
			async loadData() {
				if (!this.searchForm.logType) {
					this.$message.warning('请选择日志类型')
					return
				}
				if (!this.searchForm.day) {
					this.$message.warning('请选择查询日期')
					return
				}
				this.loading = true
				try {
					const res = await this.API.get(this.API.admin.getLogPage, this.searchForm)
					console.log('res', res.data)
					this.tableData = res.data.content
					console.log(res.data.totalElements)
					this.total = res.data.totalElements
				} catch (err) {
					// this.$message.error('查询日志失败')
				} finally {
					this.loading = false
				}
			},
			// 重置查询
			resetSearch() {
				const now = new Date()
				const year = now.getFullYear()
				let month = now.getMonth() + 1
				let day = now.getDate()
				month = month < 10 ? '0' + month : month
				day = day < 10 ? '0' + day : day
				this.searchForm = {
					logType: '',
					day: `${year}${month}${day}`,
					operator: '',
					traceId: '',
					apiName: '',
					requestUrl: '',
					requestMethod: '',
					responseStatus: null,
					ip: '',
					costMin: '',
					costMax: '',
					errorMsg: '',
					pageNum: 1,
					pageSize: 10,
					userName: '',
					platform: '',
				}
				this.tableData = []
				this.total = 0
			},
			// 分页切换
			handleCurrentChange(page) {
				this.searchForm.pageNum = page
				this.loadData()
			},
			handleSizeChange(size) {
				this.searchForm.pageSize = size
				this.searchForm.pageNum = 1
				this.loadData()
			},
			// 打开详情弹窗
			async openDetail(row) {
				try {
					const res = await this.API.get(this.API.admin.getLogDetail, {
						logType: this.searchForm.logType,
						day: this.searchForm.day,
						traceId: row.traceId
					})
					console.log('res', res.data)
					this.detail = res.data
					this.dialogVisible = true
				} catch (err) {
					this.$message.error('获取日志详情失败')
				}
			}
		}
	}
</script>

<style scoped>
	.search-card {
		margin-bottom: 10px;
	}

	/deep/ .el-descriptions__label {
		width: 120px;
	}
</style>